import { z } from "zod";
import {
  commentValidation,
  descriptionValidation,
  idValidation,
  numberValidation,
  textValidation,
  textValidationOptional,
  titleValidation,
  urlValidation,
} from "../../../utils/validation";
import { useForm, UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { TopicPartFormData } from "../../topicPart/entities/TopicPart";
import { useEffect } from "react";
import { TranslationFunction } from "../../../utils/utils";

export const useTopicPartFormValidation = (
  data: TopicPartFormData | null,
  t: TranslationFunction
): UseFormReturn<TopicPartFormData> => {
  const mediaFile = z.union([z.string(), z.instanceof(File)]).nullable().optional();

  const schema = z
    .object({
      title: titleValidation(t),
      description: descriptionValidation(t),
      topicId: idValidation(),
      timing: numberValidation(t),
      videoLink: urlValidation(t),
      videoFile: mediaFile,
      audioFile: mediaFile,
      contentText: textValidation(t),
      additionalText: textValidationOptional(),
      answerTogether: z.boolean(),
      isSynthesisPart: z.boolean(),
      comments: commentValidation(),
    })
    // Une seule source vidéo : lien externe ou fichier (règle aussi appliquée par `topicPart.pb.js`).
    .superRefine((value, ctx) => {
      if (value.videoLink && value.videoFile) {
        const message = t("topicPart.validation.videoSourceConflict");
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["videoLink"], message });
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["videoFile"], message });
      }
    });

  const form = useForm<TopicPartFormData>({
    resolver: zodResolver(schema),
    defaultValues: data || {},
  });

  useEffect(() => {
    form.reset({ ...(data ?? {}) });
  }, [data, form]);

  return form;
};
